import { createSlice } from '@reduxjs/toolkit';

interface UIState {
  faqContext: string[];
  errorMessage: string | null;
  successMessage: string | null;
}

export const initialState: UIState = {
  faqContext: [],
  errorMessage: null,
  successMessage: null,
};

export const slice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setFAQContext: (
      state: UIState,
      action: { type: string; payload: string },
    ) => {
      const elts = action.payload.split('/').filter((p) => !!p);
      const path = elts.map((p) => {
        if (Number.isInteger(Number(p))) {
          return 'details';
        }
        return p;
      });
      state.faqContext = [path.join('_')];
    },
    pushFAQContext: (
      state: UIState,
      action: { type: string; payload: string },
    ) => {
      const context = [...state.faqContext];
      context.push(action.payload);
      state.faqContext = context;
    },
    popFAQContext: (state: UIState, action: { type: string }) => {
      if (state.faqContext?.length > 1) {
        const context = [...state.faqContext];
        context.pop();
        state.faqContext = context;
      }
    },
    setErrorMessage: (
      state: UIState,
      action: { type: string; payload: string },
    ) => {
      state.errorMessage = action.payload;
    },
    setSuccessMessage: (
      state: UIState,
      action: { type: string; payload: string },
    ) => {
      state.successMessage = action.payload;
    },
    clearMessages: (state: UIState, action: { type: string }) => {
      state.errorMessage = null;
      state.successMessage = null;
    },
  },
});

export const { setFAQContext } = slice.actions;
export const { pushFAQContext } = slice.actions;
export const { popFAQContext } = slice.actions;
export const { setErrorMessage } = slice.actions;
export const { setSuccessMessage } = slice.actions;
export const { clearMessages } = slice.actions;

export const selectFAQContext = (state: { ui: UIState }) => {
  if (state.ui.faqContext?.length > 0) {
    const ctx = state.ui.faqContext;
    return ctx[ctx.length - 1];
  }
  return '';
};

export const selectErrorMessage = (state: { ui: UIState }) =>
  state.ui.errorMessage;

export const selectSuccessMessage = (state: { ui: UIState }) =>
  state.ui.successMessage;

export default slice.reducer;
